
import { PaginatedDataDTO, PaginationDTO, PaginationRestDTO } from '@bottega52/commons-pagination';
import _ from 'lodash';
import { IVarInDTO } from '../repository/jago/model/input/IVarInDTO';
import { IVarFormDTO } from '../repository/jago/model/input/IVarFormDTO';
import { IVarOutDTO } from '../repository/jago/model/output/IVarOutDTO';
import IClusterInDTO from '../repository/jago/model/input/IClusterInDTO';
import IMarketplaceInDTO from '../repository/jago/model/input/IMarketplaceInDTO';
import { IKamInDTO } from '../repository/jago/model/input/IKamInDTO';

export const VarFileAcceptedExtensions: string[] = ["pdf"]
export const VarFileName: string = "agreement"
export const VarLogoFileAcceptedExtensions: string[] = ['png', 'jpeg', 'jpg']
export const VarLogoFileName: string = "logo"
export const VarRebateLetterFileName: string = "rebate_letter"

export interface IVarPartnerLevel {
  id: number;
  level: number;
  label: string;
}

export const VarPartnerLevels: IVarPartnerLevel[] = [
  { id: 1, level: 1, label: 'partnerLevelContractSigned' },
  { id: 2, level: 2, label: 'partnerLevelRebateLetterSigned' },
  { id: 3, level: 3, label: 'partnerLevelTrainingCompleted' },
  { id: 4, level: 4, label: 'partnerLevelDemoKitPurchased' },
  { id: 5, level: 5, label: 'partnerLevelQuotationRequested' },
  { id: 6, level: 6, label: 'partnerLevelOneActiveCustomer' }
];

export const VarRegisteredPartnerLevel = 1;
export const VarPreferredPartnerLevel = 6;

export enum VarPartnerLevel {
  CANDIDATE_VAR = 'CANDIDATE_VAR',
  REGISTERED_PARTNER = 'REGISTERED_PARTNER',
  PREFERRED_PARTNER = 'PREFERRED_PARTNER',
}

export enum VarCategoryType {
  VAR = 'VAR',
  DEALER = 'DEALER',
}

export enum CustomerCategoryType {
  CUSTOMER = 'CUSTOMER',
  SIMPLIFIED_CUSTOMER = 'SIMPLIFIED_CUSTOMER',
}

export enum VarDocumentType {
  AGREEMENT = 'AGREEMENT',
  REBATE_LETTER = 'REBATE_LETTER',
}

export function decode(data: PaginationRestDTO<IVarInDTO>): PaginatedDataDTO<IVarInDTO> {
    const pagination: PaginationDTO = _.omit(data, 'content');
    return {
      content: data.content,
      pagination,
    };
}

export function decodeKam(data: PaginationRestDTO<IKamInDTO>): PaginatedDataDTO<IKamInDTO> {
  const pagination: PaginationDTO = _.omit(data, 'content');
  return {
    content: data.content,
    pagination,
  };
}

export function decodeVarContentToForm(data: IVarInDTO, clusters: IClusterInDTO[], marketplaces: IMarketplaceInDTO[], kams: IKamInDTO[]): IVarFormDTO {
  let foundCluster = clusters.filter(e=>e.id===data.clusterId).length>0?clusters.filter(e=>e.id===data.clusterId)[0]:null
  let foundMarketplace = marketplaces.filter(e=>e.id===data.marketplaceId).length>0?marketplaces.filter(e=>e.id===data.marketplaceId)[0]:null
  let foundKams = kams.filter(e=>e.email===data.kamEmail)
  return {
    id: data.id,
    name: data.name,
    address: data.address,
    categoryType: data.categoryType,
    contactEmail: data.contactEmail,
    contactPhone: data.contactPhone,
    cluster: foundCluster,
    marketplace: foundMarketplace,
    company: data.company,
    customerIds: data.customerIds,
    sfcdId: data.sfcdId,
    companyName: data.companyName,
    vat: data.vat,
    commercialRefName: data.commercialRefName,
    commercialRefEmail: data.commercialRefEmail,
    commercialRefPhone: data.commercialRefPhone,
    techRefName: data.techRefName,
    techRefEmail: data.techRefEmail,
    techRefPhone: data.techRefPhone,
    agreementFileUrl: data.agreementFileUrl,
    agreementFileName: null,
    agreementFileBase64: null,
    rebateLetterFileUrl: data.rebateLetterFileUrl,
    rebateLetterFileName: null,
    rebateLetterFileBase64: null,
    supportEmail: data.supportEmail,
    supportHours: data.supportHours,
    kam: foundKams.length>0?foundKams[0]:undefined,
    city: data.city,
    country: data.country,
    website: data.website,
    shortDescription: data.shortDescription,
    visibleOnSofiaWebsite: data.visibleOnSofiaWebsite,
    lastTrainingDate: data.lastTrainingDate,
    logoFileName: null,
    logoBase64: null,
    logoFileUrl: data.logoFileUrl,
    agreementFileExpirationDate: data.agreementFileExpirationDate,
    rebateLetterFileExpirationDate: data.rebateLetterFileExpirationDate,
    lastTrainingDateExpirationDate: data.lastTrainingDateExpirationDate,
    demoKitPurchaseDate: data.demoKitPurchaseDate,
    demoKitOrderNumber: data.demoKitOrderNumber,
    documentHistory: data.documentHistory || [],
  };
}

export function encodeVarFromForm(data: IVarFormDTO): IVarOutDTO {
    let retVal: IVarOutDTO = {
      name: data.name,
      address: data.address,
      categoryType: data.categoryType,
      contactEmail: data.contactEmail,
      contactPhone: data.contactPhone,
      customerIds: data.customerIds,
      sfcdId: data.sfcdId,
      companyName: data.companyName,
      vat: data.vat,
      commercialRefName: data.commercialRefName,
      commercialRefEmail: data.commercialRefEmail,
      commercialRefPhone: data.commercialRefPhone,
      techRefName: data.techRefName,
      techRefEmail: data.techRefEmail,
      techRefPhone: data.techRefPhone,
      agreementFileName: data.agreementFileName,
      agreementFileBase64: data.agreementFileBase64,
      rebateLetterFileName: data.rebateLetterFileName,
      rebateLetterFileBase64: data.rebateLetterFileBase64,
      supportEmail: data.supportEmail,
      supportHours: data.supportHours,
      city: data.city,
      country: data.country,
      website: data.website,
      shortDescription: data.shortDescription,
      visibleOnSofiaWebsite: data.visibleOnSofiaWebsite,
      lastTrainingDate: data.lastTrainingDate,
      logoFileName: data.logoFileName,
      logoBase64: data.logoBase64,
      agreementFileExpirationDate: data.agreementFileExpirationDate,
      rebateLetterFileExpirationDate: data.rebateLetterFileExpirationDate,
      lastTrainingDateExpirationDate: data.lastTrainingDateExpirationDate,
      demoKitPurchaseDate: data.demoKitPurchaseDate,
      demoKitOrderNumber: data.demoKitOrderNumber,
    };
    if (data.cluster&&data.cluster.id)
      retVal.clusterId = data.cluster.id;
    if (data.marketplace&&data.marketplace.id)
      retVal.marketplaceId = data.marketplace.id;
    if (data.company)
      retVal.company = data.company;
    if (data.kam && data.kam.email)
      retVal.kamEmail = data.kam.email;
    return retVal;
}

export function encodeVarInFromOut(data: IVarInDTO): IVarOutDTO {
    return {
      name: data.name,
      address: data.address,
      categoryType: data.categoryType,
      contactEmail: data.contactEmail,
      contactPhone: data.contactPhone,
      clusterId: data.clusterId,
      marketplaceId: data.marketplaceId,
      company: data.company,
      customerIds: data.customerIds,
      sfcdId: data.sfcdId,
      companyName: data.companyName,
      vat: data.vat,
      commercialRefName: data.commercialRefName,
      commercialRefEmail: data.commercialRefEmail,
      commercialRefPhone: data.commercialRefPhone,
      techRefName: data.techRefName,
      techRefEmail: data.techRefEmail,
      techRefPhone: data.techRefPhone,
      agreementFileName: null,
      agreementFileBase64: null,
      rebateLetterFileName: null,
      rebateLetterFileBase64: null,
      supportEmail: data.supportEmail,
      supportHours: data.supportHours,
      kamEmail: data.kamEmail,
      city: data.city,
      country: data.country,
      website: data.website,
      shortDescription: data.shortDescription,
      visibleOnSofiaWebsite: data.visibleOnSofiaWebsite,
      lastTrainingDate: data.lastTrainingDate,
      logoFileName: null,
      logoBase64: null,
      agreementFileExpirationDate: data.agreementFileExpirationDate,
      rebateLetterFileExpirationDate: data.rebateLetterFileExpirationDate,
      lastTrainingDateExpirationDate: data.lastTrainingDateExpirationDate,
      demoKitPurchaseDate: data.demoKitPurchaseDate,
      demoKitOrderNumber: data.demoKitOrderNumber,
    };
}